import { Chart } from 'chart.js';
import { FormatterDolar } from './formatDataTable';

export function FormatChatsOptionBarGlobal() : any {
   let data;
    return {
      layout: {
        padding: {
          top: 20 // Ajusta este valor según el espacio que necesites
        }
      },
        events: [],
        plugins: {
            datalabels: {
              color: 'white',
              font: {
                size: 10
              },
            }
          },
          
          tooltips: {
            enabled: true,
            callbacks: {
              label: function(tooltipItem, data) {
                return FormatterDolar().format(tooltipItem.yLabel);
              },
            },
          },
          scales: {
              yAxes: [{
                stacked: true,
                ticks: {
                    fontColor: "white",
                    fontStyle: 'bold',
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    padding: 10
                } ,   
                      
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                  fontColor: "white",
              } ,   
                    
          }]        
          },
          responsive: true,
          legend: {          
            position: "right",
            align: "middle"
          },
  
          hover: {
            animationDuration: 0
          },

        animation: {
          onComplete: function() {
            var chartInstance = this.chart;
            var ctx = chartInstance.ctx;
            ctx.textAlign = "left";
            ctx.font = "10";
            ctx.fillStyle = "#fff";
      
            // draw total count
            this.data.datasets[0].data.forEach(function(data, index) {
            
                var total = Number(data) + Number(this.data.datasets[1].data[index]);

              var meta = chartInstance.controller.getDatasetMeta(1);
              var posX = meta.data[index]._model.x;
              var posY = meta.data[index]._model.y;
      
              total = FormatterDolar().format(total);

              ctx.fillStyle = "white";
              ctx.fillText(total, posX - 30 , posY - 10);
            }, this);
          }
        },
      };
    };

      export function FormatChatsOptionLineGlobal() : any {
        return {
        plugins: {
          datalabels: {
            display: false
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return FormatterDolar().format(tooltipItem.yLabel);
            },
          },
        },
  
        scales: {
            yAxes: [{
              ticks: {
                  fontColor: "white",
                  fontStyle: 'bold',
                  beginAtZero: true,
                  maxTicksLimit: 8,
                  padding: 10
              } ,   
                    
          }],
          xAxes: [{
            ticks: {
                fontColor: "white",
            } ,   
                  
        }]        
        },
        responsive: true,
        legend: {          
          position: "right",
          align: "middle"
        },
      }
    };
